import React, { useState, useEffect } from 'react';
import { FaThumbsUp, FaCommentAlt, FaImage } from 'react-icons/fa';
const API_URL = "https://api.lii.com.co:5101";

const FamilyWall = ({ currentUser }) => {
  const [posts, setPosts] = useState([]);
  const [newPost, setNewPost] = useState('');
  const [newPhoto, setNewPhoto] = useState(null);
  const [newComment, setNewComment] = useState('');
  const [postIdForComment, setPostIdForComment] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);
  const [activeCommentMenu, setActiveCommentMenu] = useState(null);
  const [placeholdersVisible, setPlaceholdersVisible] = useState(true);

  const toggleCommentMenu = (commentId) => {
    setActiveCommentMenu(activeCommentMenu === commentId ? null : commentId);
  };

  useEffect(() => {
    console.log("🎟️ Token récupéré :", localStorage.getItem("token"));
  
    const fetchFamilyPosts = async () => {
      try {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        console.log("👤 Utilisateur stocké :", storedUser);
  
        if (storedUser?.familyId) {
          const url = `${API_URL}/api/posts/family/${storedUser.familyId}`;
          console.log("🔍 Envoi de la requête GET à :", url);
  
          const response = await fetch(url, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          });
  
          console.log("📡 Réponse brute reçue :", response);
          const data = await response.json();
          console.log("📩 Contenu exact de la réponse API :", JSON.stringify(data, null, 2));
  
          if (response.ok) {
            setPosts(data);
            if (data.length > 0) {
              setPlaceholdersVisible(false); // ✅ Cache les placeholders dès qu'il y a des vrais posts
            }
          } else {
            console.error("❌ Échec récupération des posts familiaux", response.status);
          }
        } else {
          console.warn("⚠️ Aucun familyId trouvé dans l'utilisateur.");
        }
      } catch (err) {
        console.error('❌ Erreur lors du chargement des posts familiaux:', err);
      }
    };
  
    fetchFamilyPosts();
  }, []);

  

  const handleAddPost = async () => {
    if (newPost.trim() === '' && !newPhoto) {
      alert('Please add text or a photo.');
      return;
    }

    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (!storedUser || !storedUser.familyId || !storedUser._id) {
      console.error("❌ Missing familyId or user information");
      return;
    }

    const formData = new FormData();
    formData.append('text', newPost);
    formData.append('author', storedUser._id);
    formData.append('familyId', storedUser.familyId);
    if (newPhoto) formData.append('photo', newPhoto);

    try {
      const response = await fetch(`${API_URL}/api/posts/family/${storedUser.familyId}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: formData,
      });

      if (!response.ok) throw new Error(`Erreur lors de la création du post familial: ${response.status}`);
      const createdPost = await response.json();
      setPosts([createdPost, ...posts]);
      setNewPost('');
      setNewPhoto(null);
    } catch (error) {
      console.error('❌ handleAddPost error:', error.message);
    }
  };

  const handlePhotoChange = (e) => setNewPhoto(e.target.files[0]);

  const toggleMenu = (id) => setActiveMenu(activeMenu === id ? null : id);

  const handleDeletePost = async (id) => {
    try {
      const response = await fetch(`${API_URL}/api/posts/${id}`, { method: 'DELETE' });
      if (!response.ok) throw new Error('Erreur lors de la suppression du post');
      setPosts(posts.filter((post) => post._id !== id));
      setActiveMenu(null);
    } catch (error) {
      console.error('Erreur dans handleDeletePost:', error.message);
    }
  };

  const handleAddComment = async (id) => {
    if (newComment.trim() === '') return;
    try {
      const response = await fetch(`${API_URL}/api/posts/family/${id}/comment`, {        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ comment: newComment, author: currentUser ? currentUser._id : 'Unknown' })
      });
  
      if (!response.ok) throw new Error('Erreur lors de l\'ajout du commentaire');
      const updatedPost = await response.json();
  
      setPosts((prevPosts) =>
        prevPosts.map((post) =>
          post._id === id ? { ...post, comments: updatedPost.comments } : post
        )
      );
      setNewComment('');
      setPostIdForComment(null);
    } catch (error) {
      console.error('Erreur dans handleAddComment:', error.message);
    }
  };
  const handleLikePost = async (id) => {
    try {
      const response = await fetch(`${API_URL}/api/posts/${id}/like`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user: currentUser ? currentUser._id : 'Unknown' })
      });
      if (!response.ok) throw new Error('Erreur lors de la mise à jour du like');
      const updatedPost = await response.json();
      setPosts(posts.map((post) => (post._id === id ? updatedPost : post)));
    } catch (error) {
      console.error('Erreur dans handleLikePost:', error.message);
    }
  };

  const handleDeleteComment = async (postId, commentId) => {
    try {
   const response = await fetch(`${API_URL}/api/posts/family/${postId}/comment/${commentId}`,  { method: "DELETE" });
      if (!response.ok) throw new Error("Erreur lors de la suppression du commentaire");

      setPosts(posts.map(post =>
        post._id === postId
          ? { ...post, comments: post.comments.filter(comment => comment._id !== commentId) }
          : post
      ));
      setActiveCommentMenu(null);
    } catch (error) {
      console.error("Erreur dans handleDeleteComment:", error.message);
    }
  };

  const placeholderPosts = [
    {
      _id: "placeholder1",
      text: "🔥 Bienvenue sur Lii ! Partagez vos souvenirs familiaux ici 📸🎉",
      author: { firstName: "L'équipe Lii", lastName: "" },
      likes: 5,
      comments: [],
    },
    {
      _id: "placeholder2",
      text: "👋 Hey ! Ajoutez une photo de famille pour inaugurer votre mur 🎊",
      author: { firstName: "Martin", lastName: "Dubois" },
      likes: 3,
      comments: [],
    },
    {
      _id: "placeholder3",
      text: "🌟 Astuce : Vous pouvez aimer, commenter et même inviter vos proches !",
      author: { firstName: "Sarah", lastName: "Lemoine" },
      likes: 8,
      comments: [],
    }
  ];

  return (
    <div className="text-center">
      <h2 className="text-lg font-bold mb-2">Mur Familial</h2>
      <p className="text-gray-600 mb-4">Partagez ici les informations importantes</p>
  
      <div className="mb-4 relative">
        <textarea
          value={newPost}
          onChange={(e) => setNewPost(e.target.value)}
          className="w-full p-4 border rounded mb-2"
          placeholder="Écrivez quelque chose..."
        />
        <div className="absolute top-3 right-4 flex items-center space-x-2">
          <label htmlFor="upload-photo" className="cursor-pointer">
            <FaImage className="text-gray-600 text-2xl hover:text-gray-800" />
          </label>
          <input
            id="upload-photo"
            type="file"
            accept="image/*"
            onChange={handlePhotoChange}
            className="hidden"
          />
        </div>
        {newPhoto && (
          <div className="mt-2 flex justify-center">
            <img
              src={URL.createObjectURL(newPhoto)}
              alt="Preview"
              className="max-w-full max-h-40 rounded border"
            />
          </div>
        )}
        <button
          onClick={handleAddPost}
          className="w-full bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition duration-300 mt-2"
        >
          Ajouter un post
        </button>
      </div>
  
      <div className="space-y-4">
        {/* Affichage des vrais posts */}
        {posts.length > 0
          ? posts.map((post) => (
              <div key={post._id} className="relative p-4 bg-gray-50 border rounded shadow">
                <div className="absolute top-2 right-2">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleMenu(post._id);
                    }}
                    className="text-gray-400 hover:text-gray-600 focus:outline-none relative z-20"
                    title="Menu"
                  >
                    &#x2026;
                  </button>
                  {activeMenu === post._id && (
                    <div className="absolute top-8 right-0 bg-white border shadow rounded z-50">
                      <ul>
                        <li
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeletePost(post._id);
                            setActiveMenu(null);
                          }}
                          className="px-4 py-2 text-sm text-red-600 hover:bg-gray-100 cursor-pointer"
                        >
                          Supprimer le post
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
  
                <p className="text-gray-800 mb-4">{post.text}</p>
                {post.photo && (
                  <div className="flex justify-center mb-4">
                    <img
                      src={`${API_URL}${post.photo}`}
                      alt="Post"
                      className="rounded max-w-full max-h-64 object-cover border"
                    />
                  </div>
                )}
                <span className="text-sm text-gray-500">
                  — {currentUser && post.author && post.author._id === currentUser._id
                    ? 'You'
                    : `${post.author.firstName} ${post.author.lastName}`}
                </span>
  
                <div className="flex justify-center gap-8 mt-2">
                  <button
                    onClick={() => handleLikePost(post._id)}
                    className="flex items-center gap-2 text-gray-600 hover:text-blue-600"
                  >
                    <FaThumbsUp />Like {post.likes}
                  </button>
                  <button
                    onClick={() => setPostIdForComment(post._id)}
                    className="flex items-center gap-2 text-gray-600 hover:text-blue-600"
                  >
                    <FaCommentAlt />Comment
                  </button>
                </div>
  
                {postIdForComment === post._id && (
                  <div className="mt-4">
                    <textarea
                      value={newComment}
                      onChange={(e) => setNewComment(e.target.value)}
                      className="w-full p-2 border rounded mb-2"
                      placeholder="Ajoutez un commentaire..."
                    />
                    <button
                      onClick={() => handleAddComment(post._id)}
                      className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700"
                    >
                      Ajouter un commentaire
                    </button>
                  </div>
                )}
  
                {/* Affichage des commentaires */}
                <div className="mt-4">
                  {post.comments?.map((comment) => (
                    <div
                      key={comment._id}
                      className="relative flex justify-between items-center mb-2 p-2 bg-gray-100 rounded"
                    >
                      <p className="text-gray-600 text-sm">
                        💬 {comment.text}{" "}
                        <span className="text-sm text-gray-400">
                          —{" "}
                          {comment.author?._id === currentUser?._id
                            ? "You"
                            : `${comment.author?.firstName || "Unknown"} ${comment.author?.lastName || ""}`}
                        </span>
                      </p>
  
                      {/* Menu pour suppression de commentaire */}
                      {comment.author?._id === currentUser?._id && (
                        <div className="relative">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleCommentMenu(comment._id);
                            }}
                            className="text-gray-400 hover:text-gray-600 focus:outline-none relative z-20"
                            title="Options"
                          >
                            &#x2026;
                          </button>
                          {activeCommentMenu === comment._id && (
                            <div className="absolute top-6 right-0 bg-white border shadow rounded z-50">
                              <ul>
                                <li
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteComment(post._id, comment._id);
                                    setActiveCommentMenu(null);
                                  }}
                                  className="px-4 py-2 text-sm text-red-600 hover:bg-gray-100 cursor-pointer"
                                >
                                  Supprimer le commentaire
                                </li>
                              </ul>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))
          : /* Placeholders si aucun post */
            [
              {
                _id: "placeholder1",
                text: "Bienvenue sur Lii ! Invitez vos proches pour commencer 🧑‍🧑‍🧒‍🧒 En attendant, postez votre premier message ici !",
                author: { firstName: "L'équipe Lii", lastName: "" },
              },
              {
                _id: "placeholder2",
                text: "Les photos des vacances seront bientôt postées ici 😁 ☀️",
                author: { firstName: "Martin", lastName: "Dubois" },
              },
              
            ].map((post) => (
              <div key={post._id} className="relative p-4 bg-gray-200 border rounded shadow opacity-75">
                <p className="text-gray-800 mb-4">{post.text}</p>
                <span className="text-sm text-gray-500">
                  — {post.author.firstName} {post.author.lastName}
                </span>
              </div>
            ))}
      </div>
    </div>
  );
}

export default FamilyWall;